<template>
  <v-container tag="section">
    <base-material-card
      color="primary"
      icon="mdi-bank"
      inline
      class="px-5 py-4 ml-0"
      title="Cadastrar Responsável"
      elevation="0"
    >
    <v-row class="mx-auto mt-6">
        <v-col cols="12">
          <h3>Selecione o Responsável</h3>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-autocomplete
            :items="users"
            item-text="name"
            item-value="id"
            v-model="selectedUser"
            label="Usuário Responsável"
            clearable
          />
        </v-col>
      </v-row>

      <v-row class="mx-auto">
        <v-col cols="12">
          <h3>Selecione o(s) Tema(s)</h3>
        </v-col>
        <v-col cols="12">
          <v-expansion-panels accordion multiple class="borda" flat>
            <v-expansion-panel>
              <v-expansion-panel-header>Empresas </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row dense>
                  <v-col class="pb-0 pt-0" cols="12">
                    <v-checkbox
                      v-model="selectAllCompanies"
                      label="Selecionar todos as empresas"
                      hide-details
                      class="mt-0"
                    />
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col
                    class="pb-0 pt-1"
                    md="2"
                    sm="4"
                    cols="6"
                    v-for="item in companies"
                    :key="item.id"
                  >
                    <v-checkbox
                      v-model="companiesSelected"
                      :label="item.name"
                      :value="item.id"
                      hide-details
                    />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                Temas Indicadores Comercial V2
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row dense>
                  <v-col class="pb-0 pt-0" cols="12">
                    <v-checkbox
                      v-model="selectAllComercialV2Categories"
                      label="Selecionar todos os temas"
                      hide-details
                      class="mt-0"
                    />
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col
                    class="pb-0 pt-1"
                    md="2"
                    sm="4"
                    cols="6"
                    v-for="item in categories.fields_indicadores_comerciais_v2_categories"
                    :key="item.id"
                  >
                    <v-checkbox
                      v-model="comercialV2SelectedCategories"
                      :label="item.category"
                      :value="item.id"
                      hide-details
                    />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                Temas Tipos de Serviços
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row dense>
                  <v-col class="pb-0 pt-0" cols="12">
                    <v-checkbox
                      v-model="selectAllTiposServicosCategories"
                      label="Selecionar todos os temas"
                      hide-details
                      class="mt-0"
                    />
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col
                    class="pb-0 pt-1"
                    md="3"
                    sm="6"
                    cols="auto"
                    v-for="item in categories.servicos_categories"
                    :key="item.id"
                  >
                    <v-checkbox
                      v-model="tiposServicosSelectedCategories"
                      :label="item.nome"
                      :value="item.id"
                      hide-details
                    />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                Temas Indicadores Subestações
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row dense>
                  <v-col class="pb-0 pt-0" cols="12">
                    <v-checkbox
                      v-model="selectAllTecSubCategories"
                      label="Selecionar todos os temas"
                      hide-details
                      class="mt-0"
                    />
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col
                    class="pb-0 pt-1"
                    md="3"
                    sm="6"
                    cols="auto"
                    v-for="item in categories.fields_indicadores_subestacoes_categories"
                    :key="item.id"
                  >
                    <v-checkbox
                      v-model="tecSubSelectedCategories"
                      :label="item.category"
                      :value="item.id"
                      hide-details
                    />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                Temas Indicadores Linhas de Distribuição
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row dense>
                  <v-col class="pb-0 pt-0" cols="12">
                    <v-checkbox
                      v-model="selectAllTecLdCategories"
                      label="Selecionar todos os temas"
                      hide-details
                      class="mt-0"
                    />
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col
                    class="pb-0 pt-1"
                    md="3"
                    sm="6"
                    cols="auto"
                    v-for="item in categories.fields_indicadores_linhas_distribuicao_categories"
                    :key="item.id"
                  >
                    <v-checkbox
                      v-model="tecLdSelectedCategories"
                      :label="item.category"
                      :value="item.id"
                      hide-details
                    />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                Temas Indicadores Alimentadores
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row dense>
                  <v-col class="pb-0 pt-0" cols="12">
                    <v-checkbox
                      v-model="selectAllTecAlCategories"
                      label="Selecionar todos os temas"
                      hide-details
                      class="mt-0"
                    />
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col
                    class="pb-0 pt-1"
                    md="3"
                    sm="6"
                    cols="auto"
                    v-for="item in categories.fields_indicadores_alimentadores_categories"
                    :key="item.id"
                  >
                    <v-checkbox
                      v-model="tecAlSelectedCategories"
                      :label="item.category"
                      :value="item.id"
                      hide-details
                    />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>

      <v-row justify="end" class="mt-4">
        <v-col cols="auto">
          <v-btn
            :disabled="!formIsValid"
            color="primary"
            @click="cadsatraResponsavel()"
          >
            Cadastrar
          </v-btn>
        </v-col>
      </v-row>
    </base-material-card>
  </v-container>
</template>

<script>
  import UsersService from "@/services/UsersService";
  import GovernancaResponsaveisTemasService from "@/services/GovernancaResponsaveisTemasService";
  import CompanyService from "@/services/CompanyService";

  export default {
    name: "AddResponsavelTemas",
    data() {
      return {
        categories: {
          fields_indicadores_comerciais_v2_categories: [],
          servicos_categories: [],
          fields_indicadores_subestacoes_categories: [],
          fields_indicadores_linhas_distribuicao_categories: [],
          fields_indicadores_alimentadores_categories: [],
        },
        users: [],
        selectedUser: null,
        companies: [],
        companiesSelected: [],
        comercialV2SelectedCategories: [],
        tiposServicosSelectedCategories: [],
        tecSubSelectedCategories: [],
        tecLdSelectedCategories: [],
        tecAlSelectedCategories: [],
        selectAllCompanies: false,
        selectAllComercialV2Categories: false,
        selectAllTiposServicosCategories: false,
        selectAllTecSubCategories: false,
        selectAllTecLdCategories: false,
        selectAllTecAlCategories: false,
      };
    },
    computed: {
      formIsValid() {
        return (
          this.selectedUser &&
          this.companiesSelected.length > 0 &&
          (this.comercialV2SelectedCategories.length > 0 ||
            this.tiposServicosSelectedCategories.length > 0 ||
            this.tecSubSelectedCategories.length > 0 ||
            this.tecLdSelectedCategories.length > 0 ||
            this.tecAlSelectedCategories.length > 0)
        );
      },
    },
    created() {
      this.getDados();
    },
    methods: {
      async getDados() {
        return Promise.all([
          this.getCompanies(),
          this.getCategories(),
          this.getUsers(),
        ]).catch((error) => {
          console.error(error);
          this.$toast.error("Falha ao recuperar dados", "", {
            position: "topRight",
          });
        });
      },
      getCompanies() {
        return CompanyService.getCompanies()
          .then((res) => {
            this.companies = res;

            if (this.companiesSelected.length == 0) {
              this.companiesSelected = [this.$store.getters.getCompanyId];
            }
          })
          .catch((err) => {
            throw err;
          });
      },
      getCategories() {
        UsersService.getIndicadoresFieldsCategories()
          .then((response) => {
            this.categories = response;
          })
          .catch((error) => {
            throw error;
          });
      },
      getUsers() {
        UsersService.getUsers()
          .then((response) => {
            this.users = response;
          })
          .catch((error) => {
            throw error;
          });
      },
      cadsatraResponsavel() {
        const payload = {
          userId: this.selectedUser,
          companies: this.companiesSelected,
          comercialV2Categories: this.comercialV2SelectedCategories,
          tiposServicosCategories: this.tiposServicosSelectedCategories,
          tecSubCategories: this.tecSubSelectedCategories,
          tecLdCategories: this.tecLdSelectedCategories,
          tecAlCategories: this.tecAlSelectedCategories,
        };

        GovernancaResponsaveisTemasService.addResponsavelTemas(payload)
          .then(() => {
            this.$toast.success("Cadastro salvo com sucesso", "", {
              position: "topRight",
            });
            this.$router.push("/administracao/governanca/responsaveis-temas");
          })
          .catch((error) => {
            this.$toast.error("Erro ao cadastrar responsável", "", {
              position: "topRight",
            });
            console.error("Erro ao cadastrar responsável:", error);
          });
      },
    },
    watch: {
      selectAllCompanies() {
        this.companiesSelected = this.selectAllCompanies
          ? this.companies.map((company) => company.id)
          : [];
      },
      selectAllComercialV2Categories() {
        this.comercialV2SelectedCategories = this.selectAllComercialV2Categories
          ? this.categories.fields_indicadores_comerciais_v2_categories.map(
              (category) => category.id
            )
          : [];
      },
      selectAllTiposServicosCategories() {
        this.tiposServicosSelectedCategories = this
          .selectAllTiposServicosCategories
          ? this.categories.servicos_categories.map((category) => category.id)
          : [];
      },
      selectAllTecSubCategories() {
        this.tecSubSelectedCategories = this.selectAllTecSubCategories
          ? this.categories.fields_indicadores_subestacoes_categories.map(
              (category) => category.id
            )
          : [];
      },
      selectAllTecLdCategories() {
        this.tecLdSelectedCategories = this.selectAllTecLdCategories
          ? this.categories.fields_indicadores_linhas_distribuicao_categories.map(
              (category) => category.id
            )
          : [];
      },
      selectAllTecAlCategories() {
        this.tecAlSelectedCategories = this.selectAllTecAlCategories
          ? this.categories.fields_indicadores_alimentadores_categories.map(
              (category) => category.id
            )
          : [];
      },
    },
  };
</script>

<style>
  .borda {
    border: 2px solid rgba(0, 0, 0, 0.1);
    border-radius: 4px;
  }
</style>
